var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../../api/axios";
/**
 *
 * @param deliveryDates currentOrderDeliveryDates
 * @param programId currentOrderProgramId
 * @param zipCode targetZipCode
 * @param LocationId
 * @returns
 */
export const checkCurrentOrderPlaceChange = (deliveryDates, programId, zipCode, LocationId) => __awaiter(void 0, void 0, void 0, function* () {
    const requestData = {
        DeliveryDates: deliveryDates,
        ProgramId: programId,
        // Only test a zip code when there is no location id to test.
        ZipCode: LocationId ? null : zipCode,
        LocationId: LocationId,
    };
    const response = yield axiosPrivate.post("/Account/DoesCurrentOrderPlaceChangeRequireReschedule", requestData);
    return {
        isAbleToBeModified: response.data.isAbleToBeModified,
        isPlaceUpdated: response.data.isPlaceUpdated,
        isRescheduleRequired: response.data.isRescheduleRequired,
        message: response.data.message,
        success: response.data.success,
        newDeliveryScheduleId: response.data.newDeliveryScheduleId
    };
});
